"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceTransferInstantOptionsSelectMode = exports.BalanceTransferActionType = void 0;
var BalanceTransferActionType;
(function (BalanceTransferActionType) {
    /** The typical balance transfer function w/ in the Aven My app */
    BalanceTransferActionType["instantBalanceTransfer"] = "instantBalanceTransfer";
    /** Debt swap balance transfer before card activation */
    BalanceTransferActionType["debtSwap"] = "debtSwap";
})(BalanceTransferActionType || (exports.BalanceTransferActionType = BalanceTransferActionType = {}));
var BalanceTransferInstantOptionsSelectMode;
(function (BalanceTransferInstantOptionsSelectMode) {
    BalanceTransferInstantOptionsSelectMode["singleSelect"] = "singleSelect";
    BalanceTransferInstantOptionsSelectMode["noSelect"] = "noSelect";
})(BalanceTransferInstantOptionsSelectMode || (exports.BalanceTransferInstantOptionsSelectMode = BalanceTransferInstantOptionsSelectMode = {}));
